module.exports = {"id":"192202","name":"Bruno César","rating":"77","photo":"./data/images/photos/4/192202.png","club":{"name":"Sporting CP","logo":"./data/images/clubs/SportingCP.png"},"positions":["MG","DG","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrunoCesar0.json
// module id = 655
// module chunks = 0